// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Ml+hp","dragging-over":"styles_dragging-over__OPRq2","draggingOver":"styles_dragging-over__OPRq2","color":"styles_color__LBClp"};